require('./accordion.scss');
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const CollapsingToggle = require('components/commons/collapsingToggle/collapsingToggle');
const CollapsingTogglePromoCode = require('components/commons/collapsingTogglePromoCode/collapsingTogglePromoCode');

class Accordion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: this.props.isExpanded,
        };

        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle() {
        const { expandable, recordEvent } = this.props;
        if (expandable) {
            if (recordEvent) {
                recordEvent(!this.state.isExpanded);
            }

            this.setState({
                isExpanded: !this.state.isExpanded,
            });
        }
    }

    getAccordionBody() {
        const { children, id } = this.props;
        const { isExpanded } = this.state;
        let accordionBody;

        if (isExpanded) {
            accordionBody = React.Children.map(children, child => {
                let body;

                if (child.props.name === 'AccordionBody') {
                    body = React.cloneElement(child, {
                        id: `sec_accordionBody_${id}`,
                        isExpanded: isExpanded,
                    });
                }

                return body;
            });
        }

        return accordionBody;
    }

    getCollapsingToggle() {
        const { expandable, customCollapsinToggle } = this.props;
        const { isExpanded } = this.state;
        let toggle;

        if (expandable) {
            toggle = (
                <CollapsingToggle
                    customCollapsinToggle={customCollapsinToggle}
                    isExpanded={isExpanded}
                    onClick={this.handleToggle}
                />
            );
        }

        return toggle;
    }

    getCollapsingTogglePromoCode() {
        const { expandable } = this.props;
        const { isExpanded } = this.state;
        let toggle;

        if (expandable) {
            toggle = <CollapsingTogglePromoCode isExpanded={isExpanded} onClick={this.handleToggle} />;
        }

        return toggle;
    }

    render() {
        const { customClassName, customTitleClassName, id, title, additionalComponent } = this.props;
        const { isExpanded } = this.state;
        const accordionId = `sec_accordion_${id}`;
        const accordionClassNames = classNames('accordion', {
            [customClassName]: customClassName,
        });
        const accordionTitleClassNames = classNames('accordion-title', {
            [customTitleClassName]: customTitleClassName,
        });
        const isExpandedClassName = classNames({
            'is-expanded': isExpanded,
        });
        const accordionBody = this.getAccordionBody();
        let collapsingToggle;

        if (id == 'promoCode') {
            collapsingToggle = this.getCollapsingTogglePromoCode();
        } else {
            collapsingToggle = this.getCollapsingToggle();
        }

        const creditCardComponent = isExpanded && additionalComponent;

        return (
            <div>
                <div id={accordionId} className={accordionClassNames}>
                    <div>
                        <div onClick={this.handleToggle} className={accordionTitleClassNames}>
                            {title}
                            {collapsingToggle}
                        </div>
                    </div>
                    <div className={classNames('accordion-transition', 'clearfix', isExpandedClassName)}>
                        {accordionBody}
                    </div>
                </div>
                {creditCardComponent}
            </div>
        );
    }
}

Accordion.propTypes = {
    children: PropTypes.any,
    customClassName: PropTypes.string,
    customCollapsinToggle: PropTypes.string,
    customTitleClassName: PropTypes.string,
    expandable: PropTypes.bool,
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isExpanded: PropTypes.bool,
    additionalComponent: PropTypes.any,
};

Accordion.defaultProps = {
    expandable: false,
    isExpanded: true,
    additionalComponent: null,
    customTitleClassName: 'accordion-title',
};

module.exports = Accordion;
